import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { MENU_LOGIN } from './routes'
import MenuPage from '../components/layouts/Menu/Index'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'
import {
  useMenuLayoutStore,
  useRightOrgProfileStore,
  useToggleMenuStore
} from '../store/layout'
import { useDispatch } from 'react-redux'
import { getRighMenuProfiletOrgAPI } from '../services/right-org'
import fnMapMenu from '../components/layouts/Menu/map-1-menu'
import { updateAllMenu } from '../actions/allMenu.action'
import { userRightOrgProfileAPI } from '../services/setting/right-org'
import { TOKEN } from '../Constants'

const ProtectedRoutes = () => {
  const token = localStorage.getItem(TOKEN)
  // const profile = JSON.parse(localStorage.getItem(PROFILE))
  // const menu = useSelector((state) => state.allMenuReducer.allMenu)

  const { isToggleMenu } = useToggleMenuStore()
  const { menuLayout, setMenuLayout, setIsLoading } = useMenuLayoutStore()

  const [orgSelete, setOrgSelete] = useState()
  const { orgRole, setOrgRole, setIsLoadingOrg } = useRightOrgProfileStore()
  const dispatch = useDispatch()
  useEffect(() => {
    const getRighMenuProfiletOrg = async () => {
      setIsLoading(true)
      const res = await getRighMenuProfiletOrgAPI()
      setIsLoading(false)

      if (!res) return
      if (res.status) {
        if (res.result.length > 0) {
          const newMenu = res.result.map((d) => {
            return fnMapMenu(d)
          })
          dispatch(updateAllMenu(newMenu))
          setMenuLayout(newMenu)
        }
      } else {
        setMenuLayout([])
      }
    }
    const userRightOrgProfile = async () => {
      const res = await userRightOrgProfileAPI()
      setIsLoadingOrg(false)
      if (!res) return
      if (res.status) {
        setOrgRole(res.result)
      } else {
        setOrgRole([])
      }
    }
    getRighMenuProfiletOrg()
    userRightOrgProfile()
  }, [])

  return token ? (
    <BodyPage>
      <MenuPage />

      <BodyContent isToggleMenu={isToggleMenu}>
        <Container fluid>
          <Outlet
            context={{
              menuLayout,
              orgRole,
              orgSelete,
              setOrgSelete
            }}
          />
        </Container>
      </BodyContent>
    </BodyPage>
  ) : (
    <Navigate to={MENU_LOGIN} />
  )
}
const BodyPage = styled.div`
  height: 100%;
  display: flex;
`
const BodyContent = styled.div`
  margin-left: 0px;
  transition: margin-left 0.3s ease-in-out;
  -webkit-box-flex: 1;
  flex-grow: 1;
  min-width: 0px;
  display: flex;
  min-height: 100vh;
  flex-direction: column;

  @media (min-width: 992px) {
    margin-left: ${(props) => (props.isToggleMenu ? 240 : 80)}px;
  }
`
export default ProtectedRoutes
